import { getTokenHeader } from "@/helpers/commonHelper";
import axios from "axios";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { uploadFile } from "@/helpers/fileHelper";
import { emailRegex } from "@/configuration/formConfigurations";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);

export default {
  name: "UserEditDialog",
  data: () => ({
    emailRegex,
    visible: false,
    dragging: false,
    password: "",
    changedAvatar: false,
    genders: [
      { value: "none", title: "----" },
      { value: "female", title: "Frau" },
      { value: "male", title: "Herr" }
    ]
  }),
  mounted() {
    setTimeout(() => {
      if (!this.editedUser?._id) window.location.href = "/login";
    }, 500);
  },
  methods: {
    async setUserPicture(e) {
      const file = e?.dataTransfer?.files?.[0] ?? e;
      if (file) {
        this.editedUser.fileData = await this.readFileUrl(file);
        this.editedUser.avatar_uri = file;
      } else {
        this.clearImage();
      }
      this.dragging = false;
      this.changedAvatar = true;
    },
    readFileUrl(file) {
      return new Promise((resolve, reject) => {
        if (file) {
          const reader = new FileReader();
          reader.onload = ({ target }) => {
            if (target?.result) resolve(target.result);
            else reject("Unable to read File");
          };
          reader.readAsDataURL(file);
        } else reject("No file passed");
      });
    },
    async uploadUserPicture() {
      if (
        this.editedUser?.fileData &&
        typeof this.editedUser?.avatar_uri !== "string"
      ) {
        const res = await uploadFile(
          this.editedUser.avatar_uri,
          this.editedUser.id,
          "users",
          this.editedUser.principal_id
        );
        delete this.editedUser.fileData;
        this.editedUser.avatar_uri = res.url;
      }
    },
    async save(close = false) {
      if (this.$refs.userForm?.validate()) {
        await this.updateUser();

        if (close) window.location.href = "/";
      }
    },
    async updateUser() {
      try {
        const headers = getTokenHeader();
        if (headers) {
          if (this.changedAvatar) await this.uploadUserPicture();
          const body = {};
          if (this.password?.length > 6) body.password = this.password;
          if (this.changedAvatar && this.editedUser?.avatar_uri)
            body.avatar_uri = this.editedUser.avatar_uri;
          body.id = this.editedUser._id;
          body.principal_id = this.editedUser.principal_id;
          body.username = this.editedUser.username;
          body.first_name = this.editedUser.first_name;
          body.last_name = this.editedUser.last_name;
          body.gender = this.editedUser.gender;
          body.email = this.editedUser.email;
          body.groups = this.editedUser.groups.map(
            group => (group = group._id)
          );
          body.email_notifications = this.editedUser.email_notifications || [];

          const response = await axios.put(
            `${env.auth_api_client_url}users/update`,
            body,
            {
              headers
            }
          );

          if (response.status === 200) {
            await this.$store.dispatch(
              "createSuccess",
              "Erfolgreich gespeichert!"
            );
            const { data } = response.data;
            if (data.avatar_uri) this.editedUser.avatar_uri = data.avatar_uri;
            this.password = "";
            this.changedAvatar = false;
          }
        }
      } catch (e) {
        await this.$store.dispatch(
          "createError",
          "Benutzername ist bereits vergeben!"
        );
      }
    },
    getUserPicture() {
      return this.editedUser?.fileData ?? this.editedUser?.avatar_uri;
    },
    async confirmRemoveAvatarImage() {
      const isConfirmed = await this.$confirm(
        "Sind Sie sicher, dass Sie das Logo löschen möchten?",
        confirmWarningConfig
      );
      if (isConfirmed) {
        await this.removeAvatarImage();
      }
    },
    async removeAvatarImage() {
      // TODO: Remove File from S3 / fix eo-file api
      this.clearImage();
    },
    clearImage() {
      this.changedAvatar = true;
      this.editedUser.avatar_uri = null;
      this.editedUser.fileData = null;
    }
  },
  computed: {
    editedUser() {
      return this.$store.state.currentUser;
    },
    isValid() {
      return (
        this.editedUser?.first_name?.length &&
        this.editedUser?.last_name?.length &&
        this.editedUser?.username?.length &&
        this.editedUser?.gender.length > 0 &&
        this.editedUser?.email?.length &&
        (this.password?.length === 0 || this.password.length > 6)
      );
    },
    roles() {
      return this.editedUser?.roles ?? [];
    },
    isAdmin() {
      return this.roles.some(r => r.id === "admin");
    },
    isExternNewsEditor() {
      if (this.isAdmin) {
        return true;
      }
      return this.roles.some(r => r.id === "extern_news_editor");
    },
    externNewsPrincipalNotification: {
      get() {
        const notifications = this.editedUser?.email_notifications || [];
        return notifications.includes("extern_news_from_principal");
      },
      set(value) {
        if (!value) {
          return;
        }

        if (!this.editedUser.email_notifications) {
          this.editedUser.email_notifications = [];
        }

        const index = this.editedUser.email_notifications.indexOf(
          "extern_news_from_principal"
        );
        if (index === -1) {
          this.editedUser.email_notifications.push(
            "extern_news_from_principal"
          );
        } else if (!value && index !== -1) {
          this.editedUser.email_notifications.splice(index, 1);
        }
      }
    }
  }
};
